import { render, staticRenderFns } from "./AbstractVersionPicker.vue?vue&type=template&id=033f8681"
import script from "./AbstractVersionPicker.vue?vue&type=script&lang=js"
export * from "./AbstractVersionPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports